(function () {
  function init(root) {
    (root || document).querySelectorAll(".quiz").forEach(setup);
  }

  function setup(quiz) {
    if (quiz.dataset.quizReady === "1") return;
    quiz.dataset.quizReady = "1";

    var steps = Array.prototype.slice.call(
      quiz.querySelectorAll(".quiz__step"),
    );
    var total = steps.length;
    if (!total) return;

    var fill = quiz.querySelector(".quiz__bar-fill");
    var bar = quiz.querySelector(".quiz__bar");
    var progress = quiz.querySelector(".quiz__progress");
    var progressWrapper = quiz.querySelector(".quiz__progress-wrapper");
    var progressSpacer = quiz.querySelector(".quiz__progress-spacer");

    // Force all progress elements to be visible and styled
    if (progressWrapper) {
      progressWrapper.style.display = "grid";
      progressWrapper.style.gridTemplateColumns =
        "minmax(0, 1fr) minmax(0, var(--qz-aside, 391px))";
      progressWrapper.style.gap = "clamp(32px, 5vw, 80px)";
    }
    if (progress) {
      progress.style.display = "block";
      progress.style.marginBottom = "34px";
    }
    if (progressSpacer) {
      progressSpacer.style.display = "block";
    }
    if (bar) {
      bar.style.height = "6px";
      bar.style.borderRadius = "999px";
      bar.style.backgroundColor = "rgba(41, 21, 12, 0.12)";
      bar.style.overflow = "hidden";
      bar.style.width = "100%";
      bar.style.display = "block";
    }
    if (fill) {
      fill.style.height = "100%";
      fill.style.borderRadius = "999px";
      fill.style.backgroundColor = "#29150c";
      fill.style.width = "0%";
      fill.style.display = "block";
      fill.style.transition = "width 0.35s ease";
    }

    var curEl = quiz.querySelector(".quiz__cur");
    var resultEl = quiz.querySelector(".quiz__result");
    var resultTitle = quiz.querySelector(".quiz__result-title");
    var resultLink = quiz.querySelector(".quiz__result-link");

    var answers = new Array(total).fill(null); // each: { url, title }
    var current = 0;
    var showingResult = false;

    function setProgress() {
      if (!fill) return;
      var done = showingResult ? total : current + 1;
      var widthPercent = (done / total) * 100;
      fill.style.width = widthPercent + "%";
      fill.style.setProperty("width", widthPercent + "%", "important");
      var quizStyle = getComputedStyle(quiz);
      var barColor = quizStyle.getPropertyValue("--qz-bar").trim() || "#29150c";
      fill.style.backgroundColor = barColor;
      fill.style.setProperty("background-color", barColor, "important");
    }

    function render() {
      steps.forEach(function (s, i) {
        s.hidden = showingResult || i !== current;
      });
      if (resultEl) resultEl.hidden = !showingResult;
      setProgress();
      if (curEl) curEl.textContent = showingResult ? total : current + 1;
    }

    function selectOption(step, opt) {
      step.querySelectorAll(".quiz__option").forEach(function (o) {
        o.classList.remove("is-selected");
        o.setAttribute("aria-checked", "false");
      });
      opt.classList.add("is-selected");
      opt.setAttribute("aria-checked", "true");
      var idx = steps.indexOf(step);
      answers[idx] = {
        url: opt.dataset.url || "",
        title: opt.dataset.title || "",
      };
    }

    function goNext() {
      if (showingResult) return;
      if (answers[current] == null) return; // must pick an option first
      if (current < total - 1) {
        current++;
        render();
        scrollTop();
      } else {
        finish();
      }
    }

    function goPrev() {
      if (showingResult) {
        showingResult = false;
        current = total - 1;
        render();
        scrollTop();
        return;
      }
      if (current > 0) {
        current--;
        render();
        scrollTop();
      }
    }

    function finish() {
      var firstUnanswered = answers.indexOf(null);
      if (firstUnanswered !== -1) {
        current = firstUnanswered;
        showingResult = false;
        render();
        return;
      }
      var counts = {};
      var titles = {};
      answers.forEach(function (a) {
        if (a && a.url) {
          counts[a.url] = (counts[a.url] || 0) + 1;
          titles[a.url] = a.title;
        }
      });
      var winner = null;
      var max = 0;
      Object.keys(counts).forEach(function (u) {
        if (counts[u] > max) {
          max = counts[u];
          winner = u;
        }
      });
      if (!winner) return; // no products configured on the chosen options

      // winner is the product URL (/products/handle). Redirect to the result page,
      // passing the winning ritual's handle so the result shows the right panel.
      var handle = winner.split("?")[0].replace(/\/+$/, "").split("/").pop();
      var base = quiz.getAttribute("data-result-url") || "/pages/quiz-result";
      window.location.href = base + "?ritual=" + encodeURIComponent(handle);
    }

    function scrollTop() {
      var top = quiz.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });
    }

    quiz.addEventListener("click", function (e) {
      var opt = e.target.closest(".quiz__option");
      if (opt && quiz.contains(opt)) {
        selectOption(opt.closest(".quiz__step"), opt);
        return;
      }
      var nx = e.target.closest(".quiz__next");
      if (nx && quiz.contains(nx)) {
        e.preventDefault();
        goNext();
        return;
      }
      var bk = e.target.closest(".quiz__back");
      if (bk && quiz.contains(bk)) {
        e.preventDefault();
        goPrev();
      }
    });

    // ---- swipe navigation ----
    //   • Mobile: finger swipe (touch)
    //   • Desktop: two-finger horizontal swipe on a trackpad (horizontal wheel)
    // Swipe left → next question, swipe right → previous
    var THRESHOLD = 45;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    quiz.addEventListener(
      "touchstart",
      function (e) {
        var t = e.changedTouches[0];
        startX = t.clientX;
        startY = t.clientY;
        tracking = true;
      },
      { passive: true },
    );
    quiz.addEventListener(
      "touchend",
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (showingResult) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.2) {
          if (dx < 0) {
            goNext();
          } else {
            goPrev();
          }
        }
      },
      { passive: true },
    );

    var wheelAccum = 0;
    var wheelLock = false;
    var wheelTimer = null;
    quiz.addEventListener(
      "wheel",
      function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // ignore vertical scroll
        if (showingResult) return;
        e.preventDefault(); // stop horizontal page scroll / browser back-forward swipe
        if (wheelLock) return;
        wheelAccum += e.deltaX;
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function () {
          wheelAccum = 0;
        }, 200);
        if (Math.abs(wheelAccum) > 40) {
          if (wheelAccum > 0) {
            goNext();
          } else {
            goPrev();
          }
          wheelAccum = 0;
          wheelLock = true; // one step per gesture
          setTimeout(function () {
            wheelLock = false;
          }, 500);
        }
      },
      { passive: false },
    );

    function updateProgressLayout() {
      if (!progressWrapper) return;
      if (window.innerWidth <= 749) {
        progressWrapper.style.display = "block";
        if (progressSpacer) {
          progressSpacer.style.display = "none";
        }
      } else {
        progressWrapper.style.display = "grid";
        progressWrapper.style.gridTemplateColumns =
          "minmax(0, 1fr) minmax(0, var(--qz-aside, 391px))";
        progressWrapper.style.gap = "clamp(32px, 5vw, 80px)";
        if (progressSpacer) {
          progressSpacer.style.display = "block";
        }
      }
    }
    window.addEventListener("resize", updateProgressLayout);
    updateProgressLayout();
    render();
  }

  // "Start Here" (landing) → hide landing, reveal the quiz, start at Q1
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-quiz-start]");
    if (!trigger) return;
    e.preventDefault();
    document.body.classList.add("quiz-active");
    var section = document.querySelector(".quiz");
    if (section) init(section.closest(".shopify-section") || document);
    window.scrollTo({ top: 0, behavior: "auto" });
  });

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });

  // Theme editor: reveal the quiz ONLY while its section is selected for editing,
  // so it never sits stacked below the landing in the preview
  function isQuizSection(el) {
    return el && el.querySelector && el.querySelector(".quiz");
  }
  document.addEventListener("shopify:section:select", function (e) {
    if (isQuizSection(e.target)) {
      init(e.target);
      document.body.classList.add("quiz-active");
    }
  });
  document.addEventListener("shopify:section:deselect", function (e) {
    if (isQuizSection(e.target)) document.body.classList.remove("quiz-active");
  });
})();
